import React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';

import paths from '../../constants/routes.json';
import { People_ContactData_contacts as Contact } from '../../types/graph/People_ContactData';

interface IProps {
  contact: Contact | null;
}

const ContactItem: React.FC<IProps> = ({ contact }) => {
  if (!contact) {
    console.log('Contact is null', contact);
    return null;
  }
  return (
    <li>
      <Link
        to={`${paths.PEOPLE}/${contact.id}`}
        className="block hover:bg-gray-50"
      >
        <div className="flex items-center px-4 py-4 sm:px-6">
          <div className="w-full flex items-center">
            {/* Agent */}

            <div className="flex flex-grow">
              <div className="flex-shrink-0">
                {_.get(contact, 'person.avatar.filePath', false) ? (
                  <img
                    className="h-12 w-12 rounded-full"
                    src={_.get(contact, 'person.avatar.filePath', '')}
                    alt="Headshot"
                  />
                ) : (
                  <svg
                    className="h-12 w-12 rounded-full text-gray-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                )}
              </div>
              <div className="ml-6 flex flex-col">
                <p className="text-sm font-medium text-primary-dark truncate">
                  {`${_.get(contact, 'person.name.full', '')}`}
                </p>
                <p className="mt-2 flex items-center text-sm text-gray-500">
                  {/* Heroicon name: solid/mail */}
                  <svg
                    className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span className="truncate">
                    {_.get(contact, 'person.email', '')}
                  </span>
                </p>
              </div>
            </div>
            {/* Company */}
            <div className="flex flex-grow">
              <div className="flex-shrink-0">
                {_.get(contact, 'company.logo.filePath', false) ? (
                  <img
                    className="h-11 rounded-md"
                    src={_.get(contact, 'company.logo.filePath', '')}
                    alt="Logo"
                  />
                ) : (
                  <svg
                    className="h-12 w-12 text-gray-300"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                )}
              </div>
              <div className="ml-6 flex flex-col">
                <p className="text-sm font-medium text-primary-dark truncate">
                  {_.get(contact, 'company.name', '')}
                </p>
                <p className="mt-2 flex items-center text-sm text-gray-500">
                  {/* Heroicon name: solid/mail */}
                  <svg
                    className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    />
                    <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                  </svg>
                  <span className="truncate">
                    {_.get(contact, 'company.title', '')}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div>
            {/* Heroicon name: solid/chevron-right */}
            <svg
              className="h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default ContactItem;
